import React from 'react';

const Loader = ({ filledColor = '#2b364b', className = '', loaderStyles = '' }) => {
  return (
    <div className={`flex justify-center items-center ${className}`}>
      <div
        className={`w-8 h-8 border-4 border-gray-200 rounded-full animate-spin ${loaderStyles}`}
        style={{ borderTopColor: filledColor }}
      ></div>
    </div>
  );
};

export default Loader;
